import React from 'react'
import BrandItem from './item.js'
import styles from './index.module.scss'

function Brands ({list, spaceFlag}) {
    return (
        <ul className={`brands lx-flex-row ${styles.brands}`}>
            <BrandItem list={list} spaceFlag={spaceFlag}></BrandItem>
        </ul>
    )
}

export default Brands;